import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import SHTabs from './SHTabs';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Stakeholders = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Stakeholders</Paragraph>
        <Text className='BaseText2'>Effective relationship with stakeholders starts by identifying each one of them and what represents them. Then, <b>we manage to identify the organizacional system that properly relates to one another and generate closer relationships and involvement of our stakeholders and shareholders in our project.</b> We divide our stakeholders according to the stage of our project: test trials, test manufacturing, interested institutes and other stakeholders. To know more about each segment click in the sections below:</Text>
        <SHTabs/>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Stakeholders;
